import { render, staticRenderFns } from "./CountryPhoneInput.vue?vue&type=template&id=1981c18e"
import script from "./CountryPhoneInput.vue?vue&type=script&lang=ts"
export * from "./CountryPhoneInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports